






















































































import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import {SelectWings} from 'wings-ui-components';
import {Action, Getter} from 'vuex-class';
import draggable from 'vuedraggable'
import RegexRowItem from "@/components/Settings/MessageCategories/RegexRowItem.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import {RegexRules} from "@/store/settings/message_categories/types";
import {cloneDeep} from "lodash";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {RegexRowItem, SelectWings, draggable}})
export default class RegexItem extends Vue {
  @Action("deleteRegexRule") actionDeleteAction: any;
  @Action("getRegexItem") actionGetRegexItem: any;
  @Action("saveRegexesPriority") saveRegexesPriority: any;
  @Action("actionLog") actionLog: any;

  @Getter("serviceProviders") serviceProvidersList: any;
  @Getter("regexRulesItem") regexRulesItem: any;
  @Prop() serviceProviderItem: any;
  @Ref('validator') validator: any;

  private modelDragon: any = [];
  private logObject: ActionLog = {};
  regexRule = this.defaultItem();
  showList: boolean = false;
  isOpen: boolean = false;
  uniqueItem: boolean = true;

  defaultItem(): RegexRules {
    return {
      regex_rules: []
    }
  }


  async getRegexByServiceProvider(id: any, showList: boolean) {
    if (!showList) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Regular expression",
        addititional_info: getTranslatedParams({service_provider: this.serviceProviderItem.name}),
      }
      try {
        await this.actionGetRegexItem(id);
        await this.actionLog(this.logObject);
        this.regexRule = this.regexRulesItem;
        this.modelDragon = cloneDeep(this.regexRule.regex_rules);
      } catch (error){
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  addRegexRules() {
    this.isOpen = true;
    this.modelDragon.push({
      service_provider_id: this.serviceProviderItem.id,
      message_category_id: null,
      regex: null,
      description: null,
      transport_id: null,
    });
  }

  onSaveAction(data: any) {
    if (data) {
      this.getRegexByServiceProvider(this.serviceProviderItem.id, false);
      this.isOpen = false;
    }
  }

  onCheckUnique(data: any) {
    let items: any = [];
    let compareItem: any = data.regex + data.transport_id + data.message_category_id;
    this.modelDragon.forEach((e: any) => {
      if (e.id != data.id) {
        items.push(e.regex + e.transport_id + e.message_category_id);
      }
    })
    this.uniqueItem = !items.some((e: any) => e === compareItem)
  }

  getServiceProviderName(id: any) {
    return this.serviceProvidersList.find((obj: any) => obj.id === id)?.name
  }


  @Watch('modelDragon', {deep: true})
  async onArrayChange(val: any) {
    if (!this.regexRulesItem.regex_rules.length || !val.length){
      return;
    }
    let ids: any = [];
    let extractedIds: any = [];
    val.forEach((e: any) => ids.push(e.id));
    this.regexRulesItem.regex_rules.forEach((e: any) => extractedIds.push(e.id));
    if (extractedIds.every((id:number, index: number) => id === ids[index])){
      return;
    }
    if (!ids.includes(undefined)) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Editing",
          action_status: "success",
          object_type: "Regular expression",
          addititional_info: getTranslatedParams({service_provider: this.serviceProviderItem.name}),
        }
        await this.saveRegexesPriority({
          service_provider_id: this.serviceProviderItem.id,
          regex_rules: ids
         });
        await this.actionLog(this.logObject);
      } catch (error){
        this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  onDeleteAction(data: any): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      if (data.regexRule.id) {
        let isConfirm: boolean = await notifyDelete();
        if (isConfirm) {
          try {
            this.logObject = {
              action_page: this.$route.meta.msgKey,
              action: "Removal",
              action_status: "success",
              object_type: "Regular expression",
              addititional_info: getTranslatedParams({service_provider: this.serviceProviderItem.name, id: data.regexRule.id}),
            }
            await this.actionDeleteAction(data.regexRule);
            await this.actionLog(this.logObject);
            this.onSaveAction(true);
            resolve();
          } catch (error) {
            this.actionLog({...this.logObject, action_status: "failed"});
            reject();
            notifyError(error);
          }
        }
      } else {
        this.modelDragon.splice(data.key, 1);
      }
    });
  }
};
